import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import type { CompanyContext } from "@/shared/api/api-client";
import { useAppShell } from "@/shell/app-shell-context";

/**
 * A empresa da URL, ou a volta pra Home.
 *
 * Toda rota sob `/empresas/:id/*` precisa da mesma coisa: se o id da
 * URL não resolve numa empresa que a pessoa acessa (link velho, empresa
 * desativada, alguém colando o id de outro cliente), não há o que
 * renderizar — e o shell já derruba pra Home. Eram oito cópias do mesmo
 * par efeito + `return null`, e a oitava esqueceria o `replace: true`,
 * que é o que impede o botão de voltar de cair no mesmo lugar de novo.
 *
 * **Devolve `null` enquanto redireciona.** Quem chama faz
 * `if (!company) return null;` — o `useEffect` só roda depois do
 * render, então a rota renderiza uma vez com `null` antes de a
 * navegação acontecer, e é por isso que o guard precisa estar nas duas
 * pontas.
 */
export function useRequireCompany(): CompanyContext | null {
  const navigate = useNavigate();
  const { company } = useAppShell();

  useEffect(() => {
    if (!company) navigate("/", { replace: true });
  }, [company, navigate]);

  return company;
}
